import { render, staticRenderFns } from "./BButton.vue?vue&type=template&id=0040d30a"
import script from "./BButton.vue?vue&type=script&lang=js"
export * from "./BButton.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./BButton.vue?vue&type=style&index=0&id=0040d30a&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports